<template>
    <div class="dropdown-detailed-wrapper">
        <b-dropdown
            :variant="variant"
            class="dropdown-light ml-auto mb-0 p-0 dropdown-toggle-icon-only"
            no-caret
            left
            @shown="onShown"
        >
            <template #button-content>
                <slot></slot>
            </template>

            <b-form-input
                v-model="text"
                :placeholder="searchPlaceholder"
                autocomplete="off"
                @keyup="search ? debouncedSearch(search, text) : null"
                ref="textSearchInput"
            />

            <div class="results-wrapper">
                <b-dropdown-item
                    v-for="item in itemListInView"
                    @click="handleClick(item)"
                >
                    <div class="d-flex flex-column">
                        <small v-if="item[secondaryItemTextProperty] && item[secondaryItemTextProperty]">
                            {{ item[secondaryItemTextProperty] }}
                        </small>

                        <p class="m-0 text-muted" v-if="item[itemTextProperty] && item[itemTextProperty]">
                            {{ item[itemTextProperty] }}
                        </p>
                    </div>
                </b-dropdown-item>
            </div>
        </b-dropdown>
    </div>
</template>

<script>
import _ from 'lodash'

export default {
    name: 'DropdownDetailed',

    props: {
        itemTextProperty: {
            type: String,
        },
        itemClick: {
            type: Function,
            required: true,
        },
        itemList: {
            type: Array,
            required: true,
        },
        search: {
            type: Function,
        },
        searchPlaceholder: {
            type: String,
            default: 'Enter text to search',
        },
        variant: {
            type: String,
            default: 'link',
        },
        secondaryItemTextProperty: {
            type: String
        },
        game: {
            type: String
        },
    },

    data() {
        return {
            text: '',
        }
    },

    computed: {
        itemListInView() {
            if (!this.text) return this.itemList

            if (!this.search) {
                return _.filter(this.itemList, (item) => {
                    return item[this.itemTextProperty].toLowerCase().includes(this.text.toLowerCase())
                })
            }

            return this.itemList
        },
    },

    methods: {
        debouncedSearch: _.debounce((search, text) => {
            search(text)
        }, 500),

        handleClick(item) {
            this.itemClick(item)
            this.text = ''

            if (this.search) {
                this.search()
            }
        },

        onShown() {
            if (this.$refs.textSearchInput) {
                this.$refs.textSearchInput.focus()
            }
        },
    }
}
</script>

<style lang="scss">
.dropdown-detailed-wrapper {
    .dropdown-item {
        &:not(:last-child) {
            border-bottom: 1px solid #12141d;
        }

        &:hover {
            background-color: rgba(255, 255, 255, 0.075);

            small {
                color: #fcd878;
            }
        }
    }
}

</style>
